import { nextTick } from 'vue';

// NOTE :: Dedicated cross-tab signal for an auth transition (login / 2FA / readiness /
// password-expired / password-reset / email-verification). The value is unique on every call, so the
// `storage` event ALWAYS fires in other tabs. Watching the auth refs directly is not reliable: a
// transition changes several keys at once, their storage events arrive in no guaranteed order, and an
// unchanged value fires no event at all (e.g. `is-logged` still `true` after a stale logout). One
// signal fired after the state is written sidesteps all of that.
const AUTH_SYNC_KEY = 'af-auth-sync';

// NOTE :: The write is deferred to the next tick on purpose. The auth state (isLogged / pending* /
// shelterProfile) is vueuse `useStorage`, which persists on a `flush: 'pre'` watcher (a microtask).
// Firing the signal on `nextTick` guarantees a listening tab reads the already-flushed state, so
// callers can broadcast right after mutating the store without wiring their own `nextTick`.
function broadcastAuthAdvance() {
  void nextTick(() => localStorage.setItem(AUTH_SYNC_KEY, `${Date.now()}:${crypto.randomUUID()}`));
}

export { AUTH_SYNC_KEY, broadcastAuthAdvance };
